/**
 * Import Dependency
 */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Flex, Modal } from 'antd-mobile'
// import SwipeableBottomSheet from 'react-swipeable-bottom-sheet'
// import Scrollbar from 'smooth-scrollbar-react'
import injectSheet from 'react-jss'
import lang from 'lodash/lang'
// import array from 'lodash/array'
// import collection from 'lodash/collection'
import object from 'lodash/object'
import cx from 'classnames'
import styles from '../assets/styles/components/CategoryDetail'
import cloudinary from 'helpers/cloudinary'
import { IPHONEX_WIDTH } from '../constants/mediaQuery'

/**
 * Import Container
 */
import CategoryDetailListContainer from '../containers/components/CategoryDetailList'
// import OptionGroupsContainer from '../containers/components/OptionGroups'
// import ItemOptionsTotalContainer from '../containers/components/ItemOptionTotal'
// import CheckoutContainer from '../containers/scenes/Checkout'

/**
 * Declare Variable
 */

/**
 * Component
 */
function closest (el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el
    }
    el = el.parentElement
  }
  return null
}

class CategoryDetailComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      isTriggerItemCoverImageModal: false,
      itemCoverImageOfModal: '',
      itemTitleOfModal: '',
      itemDescriptionOfModal: '',
      bannerImgHeight: 0,
      didBannerImgLoaded: false,
    }
  }

  componentDidUpdate = () => {
    const navBarSwiperSelector = document.querySelector('#bannerImg')
    this.navBarSwiperDomElement = ReactDOM.findDOMNode(navBarSwiperSelector)
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resizeDimension)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeDimension)
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    const {
      stashByOptionGroups,
    } = this.props
    if (stashByOptionGroups !== nextProps.stashByOptionGroups) {
      return false
    }
    return true
  }

  resizeDimension = () => {
    this.setState({
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
    })
  }

  renderCategoryDetailList = () => {
    const {
      // classes,
      // match,
      history,
    } = this.props

    // const activityIndicatorWrapStyle = cx(classes['activity-indicatior-wrap'])
    // const checkoutContainerStyle = cx(classes['checkout-container'])

    if (history.location.pathname !== '/basket/checkout') {
      return (
        <CategoryDetailListContainer
          bannerImgHeight={this.state.bannerImgHeight}
          triggerItemCoverImageModal={this.triggerItemCoverImageModal}
        />
      )
    }
  }

  onCoverImgLoaded = () => {
    if (!this.state.didBannerImgLoaded && this.navBarSwiperDomElement && this.navBarSwiperDomElement.getBoundingClientRect() &&
      this.navBarSwiperDomElement.getBoundingClientRect() && this.navBarSwiperDomElement.getBoundingClientRect().height > 0) {
      this.setState({
        didBannerImgLoaded: true,
        bannerImgHeight: this.navBarSwiperDomElement.getBoundingClientRect().height,
      })
    }
  }

  renderCategoryDetailBackgroundImage = () => {
    const {
      classes,
      match,
      user,
      merchant,
      selectedCategory,
    } = this.props

    let categoryDetailBackgroundImageStyle = ''
    let categoryDetailBackgroundImageWithPaddingStyle = ''
    const categoryDetailBackgroundWithoutImageStyle = cx(classes['without-background-image'])

    if (!lang.isEmpty(selectedCategory)) {
      if (!lang.isEmpty(selectedCategory.categories)) {
        categoryDetailBackgroundImageStyle = cx(classes['with-subcate-backgroud-image'])
        categoryDetailBackgroundImageWithPaddingStyle = cx(classes['with-subcate-background-image-padding'])
      }
    } else {
      categoryDetailBackgroundImageStyle = cx(classes['default-backgroud-image'])
    }

    if (match.params.id !== 'promo' && !lang.isEmpty(match.params)) {
      if (!merchant ||
        !merchant.images ||
        // eslint-disable-next-line no-mixed-operators
        !merchant.images.banner ||
        // eslint-disable-next-line no-mixed-operators
        user.permissions &&
        user.permissions.indexOf(merchant.id + ':waiter') >= 0) {
        return (
          <Flex className={object.has(match.params, 'step') ? ' ' : categoryDetailBackgroundWithoutImageStyle} />
        )
      }

      return (
        <Flex className={categoryDetailBackgroundImageStyle}>
          <Flex.Item>
            <img
              id='bannerImg'
              onLoad={this.onCoverImgLoaded}
              src={cloudinary.transformation(merchant.images.banner, `w_${IPHONEX_WIDTH}`)}
              width='100%'
              height='auto'
              style={{ objectFit: 'contain' }}
              className={categoryDetailBackgroundImageWithPaddingStyle}
              alt=''
            />
          </Flex.Item>
        </Flex>
      )
    }
  }

  triggerItemCoverImageModal = (image, title, desc) => () => {
    if (!this.state.isTriggerItemCoverImageModal && !image) return
    this.setState({
      isTriggerItemCoverImageModal: !this.state.isTriggerItemCoverImageModal,
      itemCoverImageOfModal: image || '',
      itemTitleOfModal: title || '',
      itemDescriptionOfModal: desc || '',
    })
  }

  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return
    }
    const pNode = closest(e.target, '.am-modal-content')
    if (!pNode) {
      e.preventDefault()
    }
  }

  render () {
    const {
      classes,
      // stash,
      // stashByOptionGroups,
      match,
      intl,
      selectedCategory,
      isStickyNavbarSwiper,
      shouldShowPromoImage,
      promoImageUrl,
      onPromoImageClose,
      hideClose,
    } = this.props

    // Intl
    const _dialogGoBackText = intl.formatMessage({ id: 'dialog.go_back' })

    // const wrapStyle = cx(classes['wrap']);
    const isSetCategory = object.has(match.params, 'step')
    const wrapStyle = isStickyNavbarSwiper && isSetCategory ? cx(classes.wrap, classes['wrap-sticky']) : cx(classes.wrap)

    // const itemCoverImageModalWrapStyle = cx(classes['item-cover-image-modal-wrap'])
    const closeBtnStyle = cx(classes['close-btn'])
    const itemCoverImageModalStyle = cx(classes['item-cover-image-modal'])
    let ItemCoverImageModalElement = ''
    let subCategoryMarginBufferStyle = ''

    if (selectedCategory) {
      subCategoryMarginBufferStyle = cx(classes['subcategory-margin-buffer'])
    } else {
      subCategoryMarginBufferStyle = cx(classes['subcategory-margin-without-buffer'])
    }

    if (this.state.isTriggerItemCoverImageModal) {
      ItemCoverImageModalElement = (
        <Modal
          visible={this.state.isTriggerItemCoverImageModal}
          transparent
          maskClosable
          className={itemCoverImageModalStyle}
          onClose={this.triggerItemCoverImageModal()}
          // title={this.state.itemTitleOfModal}
          footer={[{
            text: _dialogGoBackText,
            onPress: () => {
              this.triggerItemCoverImageModal()()
            },
          }]}
          wrapProps={{
            onTouchStart: this.onWrapTouchStart,
          }}
        >
          <div style={{
            padding: 8,
            maxHeight: `${this.state.screenHeight - 200}px`,
            overflow: 'scroll',
          }}
          >
            <p style={{
              fontSize: 16,
              color: '#000000',
            }}>
              {this.state.itemTitleOfModal}
            </p>
            <p style={{ whiteSpace: 'break-spaces' }}>{this.state.itemDescriptionOfModal}</p>
            <img
              src={cloudinary.transformation(this.state.itemCoverImageOfModal, `w_${IPHONEX_WIDTH}`)}
              width='100%'
              alt=''
            />
          </div>
        </Modal>
      )
    } else if (shouldShowPromoImage) {
      ItemCoverImageModalElement = (
        <Modal
          visible={shouldShowPromoImage}
          transparent
          maskClosable
          className={cx(classes['app-promo-modal'])}
          onClose={() => {
            onPromoImageClose()
          }}
          title={this.state.itemTitleOfModal}
          footer={!hideClose && [{
            text: _dialogGoBackText,
            onPress: () => {
              onPromoImageClose()
            },
          }]}
          wrapProps={{
            onTouchStart: this.onWrapTouchStart,
          }}
        >
          <div style={{
            maxHeight: `${this.state.screenHeight - 0}px`,
            overflow: 'scroll',
          }}
          >
            {
              this.state.itemDescriptionOfModal &&
            <p>
              {this.state.itemDescriptionOfModal}
            </p>
            }
            <span className={closeBtnStyle}
              onClick={() => {
                onPromoImageClose()
              }}>x</span>
            <img
              src={cloudinary.transformation(promoImageUrl, `w_${IPHONEX_WIDTH}`)}
              width='100%'
              className={cx(classes['app-promo-img'])}
              alt=''
              onClick={() => {
                if (hideClose) {
                  window.open('https://s.dimorder.com/installpopup')
                }
              }}
            />
          </div>
        </Modal>
      )
    }

    return (
      <div className={wrapStyle}>

        {this.renderCategoryDetailBackgroundImage()}

        <Flex>
          <Flex.Item className={subCategoryMarginBufferStyle}>
            {!hideClose && this.renderCategoryDetailList()}
          </Flex.Item>
        </Flex>

        {ItemCoverImageModalElement}

      </div>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(CategoryDetailComponent)



// WEBPACK FOOTER //
// ./src/components/CategoryDetail.js